import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Row, Col, FormGroup, Label, Card, CardBody, CardText } from 'reactstrap';
import TextArrayField from '../../TextArrayField/TextArrayField';

const GetResponseFields = () => {
    const { t }                  = useTranslation();
    const { isMobile, isTablet } = useSelector(state => state.ui);

    return (
        <div className="GetResponseFields">
            <Row>
                <Col>
                    <Card>
                    { ['newsletter', 'survey'].map(key => (
                        <CardBody key={key}>
                            <h5 className="IntegrationConfig-blockTitle">
                                { t(`settings.integrations.getresponse.${key}`) }
                            </h5>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.getresponse.api_key")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.getresponse.${key}.api_key`} id="api_key" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.getresponse.campaign_id")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.getresponse.${key}.campaign_id`} id="campaign_id" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.getresponse.tags")}</Label>
                                            <Col lg={10} >
                                                <TextArrayField name={`integrations.getresponse.${key}.tags`} id="tag" addTag={(v) => console.log(v)} />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>

                            <h6 className="IntegrationConfig-blockSubtitle">{ t('settings.integrations.getresponse.custom_fields.title') }</h6>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.getresponse.custom_fields.city")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.getresponse.${key}.custom_fields.city`} id="city" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.getresponse.custom_fields.address")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.getresponse.${key}.custom_fields.address`} id="address" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.getresponse.custom_fields.country")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.getresponse.${key}.custom_fields.country`} id="country" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.getresponse.custom_fields.zip")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.getresponse.${key}.custom_fields.zip`} id="zip" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    ))}
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default GetResponseFields;
